<template>
  <v-container
    fluid
    class="pt-0"
  >    
    <slot name="navigation" />
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-row>
          <v-col class="py-0">
            <employee-profile-card
              ref="profile"
              :user-uid="userUid"
              :person-uid="personUid"
              :employee-uid="employeeUid"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="!isMyProfile"
        >
          <v-col class="pt-0">
            <employee-away-card :employee-uid="employeeUid" />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pt-0">
            <employee-employment-card :employee-uid="employeeUid" />
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            v-if="!isMyProfile && $hasPermissionTo(['list login periods'])"             
          >
            <user-login-periods-card :user-uid="userUid" />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="8"   
      >
        <material-card
          class="card-tabs"
          color="success"
        >
          <v-col
            slot="header"
          >
            <v-tabs
              v-model="active"
              background-color="transparent"
              slider-color="white"
              fixed-tabs
              center-active
              show-arrows
              icons-and-text
            >
              <v-tab                
                v-for="item in filteredTabItems"
                :key="item.name"
              >
                {{ item.name }}
                <v-icon> {{ item.icon }} </v-icon>
              </v-tab>
            </v-tabs>
          </v-col>

          <v-tabs-items 
            v-model="active"
          >
            <v-tab-item>
              <person-container-view
                :person-uid="personUid"
                :employee-uid="employeeUid"
              />   
              <v-row>
                <v-col 
                  cols="12" 
                  xl="7"
                >
                  <employee-skills-container-view
                    :employee-uid="employeeUid"
                    @updated="refreshRequirements"
                  />
                </v-col>                
                <v-col 
                  cols="12" 
                  xl="5"
                >
                  <employee-report-to-container-view 
                    :employee-uid="employeeUid" 
                    :user-uid="userUid"
                  />
                </v-col>
              </v-row>  
            </v-tab-item>
         
            <!-- <v-tab-item v-if="isMyProfile || $hasPermissionTo(['view family members'])">
              <employee-family-members-container-view
                :employee-uid="employeeUid"
                :is-my-profile="isMyProfile"
              />
            </v-tab-item> -->

            <v-tab-item v-if="!isMyProfile">
              <div 
                v-for="type in roleTypes" 
                :key="type"
              >
                <user-roles-container-view     
                  :ref="`${type}Role`"          
                  :user-uid="userUid"
                  :type="type"
                /> 
    
                <v-divider />
              </div>
            </v-tab-item>

            <v-tab-item v-if="!isMyProfile">
              <user-companies-container-view
                ref="companies"
                :user-uid="userUid"
              />
              
              <v-divider />
              <div>
                <user-state-container-view 
                  ref="state"
                  :employee-uid="employeeUid"
                />
              </div>

              <v-divider />
              <div v-show="!isMyProfile">
                <user-access-container-view 
                  ref="access"
                  :user-uid="userUid"
                />

                <v-divider />
              </div>

              <div v-show="!isMyProfile">
                <user-system-access-container-view 
                  v-if="$hasPermissionTo(['list user password attempts'])"
                  ref="systemAccess"
                  :user-uid="userUid"
                />

                <v-divider />
              </div>

              <user-approval-limits-container-view 
                ref="approval"
                :user-uid="userUid"
              />
            </v-tab-item>

            <v-tab-item>
              <user-charts-kpi-card-overview 
                v-if="employeeUid"
                ref="kpi"
                :employee="employee" 
              />
            </v-tab-item>

            <v-tab-item v-if="!isMyProfile">
              <employee-incidents-container-view
                ref="incident"
                :employee-uid="employeeUid" 
              />
            </v-tab-item>

            <!-- <v-tab-item v-if="!isMyProfile">
              <person-recruitment-container-view
                ref="recruitment"
                :person-uid="personUid"
              />
            </v-tab-item> -->

            <v-tab-item v-if="isMyProfile || $hasPermissionTo(['view promises'])">
              <employee-promises-container-view
                ref="promise"
                :employee-uid="employeeUid" 
              />
            </v-tab-item>

            <v-tab-item>
              <task-container-view 
                ref="task"
                :is-profile-tab="true"
                :employee-uid="employeeUid"
                :is-my-profile="isMyProfile"
              />
            </v-tab-item>

            <v-tab-item v-if="!isMyProfile && $hasPermissionTo(['view employee time clock'])">
              <timeclock-container-view 
                ref="timeclock"
                :is-profile-tab="true"
                :employee-uid="employeeUid"
                :is-my-profile="isMyProfile"
              />
            </v-tab-item>

            <v-tab-item>
              <employee-notifications-container-view
                :is-profile-tab="true"
                :employee-uid="employeeUid"
                :is-my-profile="isMyProfile"
              />
              <!-- <v-divider v-if="isMyProfile" />      
              
              <employee-leaves-entitlement-settings-container-view
                :is-profile-tab="true"
                :employee-uid="employeeUid"
                :is-my-profile="isMyProfile"
              /> -->
              <v-divider v-if="!isMyProfile && $hasPermissionTo(['attendance setting view'])" />      
              
              <employee-attendances-container-view
                v-if="!isMyProfile && $hasPermissionTo(['attendance setting view'])"
                :employee-uid="employeeUid"
              />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeePromisesContainerView: () => import('@/components/employee/promises/ContainerView'),
      EmployeeProfileCard: () => import('@/components/employee/ProfileCard'),
      EmployeeEmploymentCard: () => import('@/components/employee/EmploymentCard'),
      EmployeeSkillsContainerView: () => import('@/components/employee/skills/ContainerView'),
      EmployeeReportToContainerView: () => import('@/components/employee/report-to/ContainerView'),
      EmployeeIncidentsContainerView: () => import('@/components/employee/incidents/ContainerView'),
      PersonContainerView: () => import('@/components/person/ContainerView'),
      // PersonRecruitmentContainerView: () => import('@/components/person/recruitment/ContainerView'),
      UserRolesContainerView: () => import('@/components/user/roles/ContainerView'),
      UserCompaniesContainerView: () => import('@/components/user/companies/ContainerView'),
      UserStateContainerView: () => import('@/components/user/state/ContainerView'),
      UserAccessContainerView: () => import('@/components/user/access/ContainerView'),
      UserSystemAccessContainerView: () => import('@/components/user/system-access/ContainerView'),
      UserApprovalLimitsContainerView: () => import('@/components/user/approval-limits/ContainerView'),
      UserChartsKpiCardOverview: () => import('@/components/user/charts/KpiCardOverview'),
      UserLoginPeriodsCard: () => import('@/components/user/login-periods/Card'),
      TaskContainerView: () => import('@/components/task/ContainerView'),
      TimeclockContainerView: () => import('@/components/timeclock/ContainerView'),
      EmployeeAwayCard: () => import('@/components/employee/AwayCard'),
      EmployeeNotificationsContainerView: () => import('@/components/employee/notifications/ContainerView'),
      // EmployeeLeavesEntitlementSettingsContainerView: () => import('@/components/employee/leaves/entitlement-settings/ContainerView'),
      EmployeeAttendancesContainerView: () => import('@/components/employee/attendances/ContainerView'),
      // EmployeeFamilyMembersContainerView: () => import('@/components/employee/family-members/ContainerView'),
    },

    props: {
      employeeUid: {
        type: String,
        default: '',
      },
      personUid: {
        type: String,
        default: '',
      },
      userUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        tabItems: [
          { name: 'Profile', icon: 'mdi-account' },
          // { name: 'Family', icon: 'mdi-account-network' },
          { name: 'Performance', icon: 'mdi-chart-line' }, 
          // { name: 'Promises', icon: 'fas fa-handshake' },
          // { name: 'Task', icon: 'fas fa-tasks' },
        ],
        roleTypes: ['workspace', 'crm', 'ams', 'cms', 'master', 'lmspro', 'ap'],
        active: null,
        kpiLoaded: false,
      }
    },
    computed: {   
      ...mapState({ employee: 'currentEmployee' }),
      filteredTabItems () {
        let originalTab = [...this.tabItems]
        // originalTab.splice(originalTab.length, 0, { name: 'Settings', icon: 'mdi-settings' })

        if (this.isMyProfile) return originalTab

        let modifiedTab = [...this.tabItems]

        modifiedTab.splice(1, 0, { name: 'Roles', icon: 'mdi-account-multiple-outline' })
        modifiedTab.splice(2, 0, { name: 'User Access', icon: 'mdi-settings' })
        modifiedTab.splice(4, 0, { name: 'Incidents', icon: 'mdi-note-plus' })
        modifiedTab.splice(8, 0, { name: 'Away', icon: 'fas fa-clock' })
        
        if (!this.$hasPermissionTo(['view promises'])) {
          modifiedTab.splice(
            modifiedTab.findIndex(tab => {
              return tab.name === 'Promises'
            }) 
            , 1)
        }
        
        if (!this.$hasPermissionTo(['view employee time clock'])) {
          modifiedTab.splice(
            modifiedTab.findIndex(tab => {
              return tab.name === 'Away'
            }) 
            , 1)
        }

        modifiedTab.splice(modifiedTab.length, 0, { name: 'Settings', icon: 'mdi-settings' })

        return modifiedTab 
      },
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
 
    },  
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.$resetData()
            this.kpiLoaded = false
          }
        },
      },
    },
    methods: {
      refreshRequirements () {
        this.$refs.profile.loadEmployeeSkills()
        this.$refs.profile.loadEmployeePosition()
      },
  
    },
  }
</script>
